export const useBbkEnv = (): 'dev' | 'staging' | 'prod' => {
  const envMeta = document.querySelector('meta[name="environment"]');
  const env = envMeta?.getAttribute('value');

  return env === 'dev' ? 'dev' : env === 'staging' ? 'staging' : 'prod';
};
